export default {
  root: {
    backgroundColor: 'white',
    border: '1px solid black',
    borderRadius: '5px',
    padding: '0.5rem',
    paddingBottom: '0.3rem',
    position: 'relative',
    overflow: 'hidden',
    cursor: 'pointer',
    boxSizing: 'unset',
    '&:hover svg': {
      opacity: '1',
    },
  },
  colors: {
    backgroundColor: '#dae1e4',
    height: '150px',
    width: '100%',
    borderRadius: '5px',
    overflow: 'hidden',
  },
  title: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '0',
    color: 'black',
    paddingTop: '0.3rem',
    fontSize: '0.9rem',
    fontWeight: '600',
    letterSpacing: '1px',
    position: 'relative',
  },
  emoji: {
    marginLeft: '0.5rem',
    fontSize: '1.5rem',
  },
  miniColor: {
    height: '25%',
    width: '20%',
    display: 'inline-block',
    margin: '0 auto -3.5px',
    position: 'relative',
  },
  deleteIcon: {
    opacity: '0',
    backgroundColor: 'rgba(235, 61, 48, 0.9)',
    color: 'white',
    width: '20px',
    height: '20px',
    position: 'absolute',
    right: '0',
    top: '0',
    padding: '7.5px',
    zIndex: '2',
    transition: 'all 0.3s ease-in-out',
  },
};
